import { SnackbarProvider } from 'notistack'
import React from 'react'
import { ApolloConnectProvider } from './apollo'
import { EditModeProvider } from './EditMode'
import { GlobalStateProvider } from './GlobalState'

const ProvidersWrapper: React.FC = ({ children }) => {
  return (
    <ApolloConnectProvider>
      <GlobalStateProvider>
        <EditModeProvider>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            {children}
          </SnackbarProvider>
        </EditModeProvider>
      </GlobalStateProvider>
    </ApolloConnectProvider>
  )
}

export default ProvidersWrapper
